// Small shared helpers for the Set Search components. No React here.

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// 'YYYY-MM-DD' (or a dateKey: '1977-05-08T00:00:00Z', '1997_12_31') -> 'May 8, 1977'
export const fmtDateLong = (raw) => {
  const m = /^(\d{4})[-_](\d{2})[-_](\d{2})/.exec(String(raw || ''));
  if (!m) return String(raw || '');
  const mo = parseInt(m[2], 10);
  if (mo < 1 || mo > 12) return m[1];
  return MONTHS[mo - 1] + ' ' + parseInt(m[3], 10) + ', ' + m[1];
};

export const fmtCount = (n) => (typeof n === 'number' && Number.isFinite(n) ? n.toLocaleString('en-US') : String(n == null ? '' : n));

// plural(1, 'show') -> '1 show'; plural(24, 'show') -> '24 shows'
export const plural = (n, one, many) => fmtCount(n) + ' ' + (n === 1 ? one : many || one + 's');

export const ordinal = (n) => {
  const v = Math.abs(parseInt(n, 10));
  if (!Number.isFinite(v)) return '';
  const t = v % 100;
  if (t >= 11 && t <= 13) return v + 'th';
  return v + (['th', 'st', 'nd', 'rd'][v % 10] || 'th');
};

export const cutLabel = (s, max) => {
  const str = String(s == null ? '' : s);
  return str.length <= max ? str : str.slice(0, Math.max(0, max - 3)).replace(/\s+\S*$/, '') + '...';
};

// Lowercase, strip accents and punctuation, "&" -> "and". Used to match typed
// text against song names and their setlist.fm variants.
export const normText = (s) =>
  String(s == null ? '' : s)
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

// Sort labels for the find `sort` values (B.3). Only the sorts listed in
// meta.features.sorts are ever offered.
export const SORT_LABELS = {
  date: 'Oldest first',
  '-date': 'Newest first',
  rating: 'Top rated',
  downloads: 'Most downloaded',
  jams: 'Longest jams',
  rare: 'Deep cuts',
};

export const sortOptions = (sorts) =>
  (Array.isArray(sorts) ? sorts : ['date', '-date']).filter((s) => SORT_LABELS[s]).map((s) => ({ value: s, label: SORT_LABELS[s] }));

// B.2 meta.features with every flag defaulting to off.
export const featuresOf = (meta) => {
  const f = (meta && meta.features) || {};
  return {
    slots: !!f.slots,
    setTwo: !!f.setTwo,
    sandwich: !!f.sandwich,
    jam: !!f.jam,
    sbd: !!f.sbd,
    vibes: Array.isArray(f.vibes) ? f.vibes.filter((v) => v && v.key) : [],
    sorts: Array.isArray(f.sorts) ? f.sorts : ['date', '-date'],
    // setlist band that also searches shows matched from tape titles (SPEC 6.3)
    tracksFill: !!(meta && meta.mode === 'setlist' && f.tracksFill),
  };
};

// Copy text to the clipboard. Resolves true on success. Never rejects.
export const copyText = (text) => {
  const fallback = () => {
    try {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.top = '-1000px';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand('copy');
      document.body.removeChild(ta);
      return ok;
    } catch (e) {
      return false;
    }
  };
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).then(
        () => true,
        () => fallback()
      );
    }
  } catch (e) {
    /* fall through */
  }
  return Promise.resolve(fallback());
};

// Stop react-select (and any other ancestor handler) from seeing events that
// belong to our own buttons and popovers rendered inside its control.
export const stopEvent = (e) => e.stopPropagation();
